import React, { FC, useCallback, useRef, useState } from 'react';
import MosaicChartImage from '../../../components/ChartsImages/MosaicChartImage';
import { Group } from '@visx/group';
import { useWindowSize } from '../../../utils';
import styled from 'styled-components';

const StyledContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  overflow: hidden;
  z-index: 0;
`;

const StyledMultipleMosaicChartSvg = styled.svg`
  z-index: 1;
`;

const MosaicContent: FC<any> = ({
  sort,
  chartId,
  data,
  color,
  margin,
  showItemsPreview,
  handleMouseMove,
  handleMouseLeave
}) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const windowSize = useWindowSize();
  const svgRef = useRef(null);

  const chartRef = useCallback(
    (node) => {
      if (node != null) {
        setWidth(node.getBoundingClientRect().width);
        setHeight(node.getBoundingClientRect().height);
      }
    },
    [windowSize, data]
  );

  const getMultiTargetBars = useCallback(
    (item, x, y, width) => {
      let rectX = x;

      const bars = item.bars;
      return bars.map((bar, index) => {
        const rectWidth = (bar.width / 100) * width;
        const rect = (
          <rect
            key={`multiple-mosaic-${chartId}-rect-${index}-${x}-${y}`}
            x={rectX}
            y={y}
            width={rectWidth}
            height={15}
            fill={bar.color}
          />
        );
        rectX += rectWidth;
        return rect;
      });
    },
    [chartId]
  );
  const numColumns = sort !== 'similar' ? 2 : 5;
  const numRows = 5;
  const rowHeight = Math.max(height / numRows, 0);

  return (
    <StyledContentWrapper ref={chartRef}>
      <StyledMultipleMosaicChartSvg
        ref={svgRef}
        width={width}
        height={
          Math.floor((data.length - 1) / numColumns) * rowHeight + rowHeight
        }
      >
        <rect width={width} height={height} fill='#ffffff' />
        <Group
          top={margin.top}
          left={margin.left}
          key={`group-${chartId.current}`}
        >
          {data.map((item: any, index) => {
            const numRows = 5;
            const rowHeight = Math.max(height / numRows, 0);
            const numColumns = sort !== 'similar' ? 2 : 5;
            const columnWidth = Math.max(width / numColumns, 0);

            const columnIndex = index % numColumns;
            const rowIndex = Math.floor(index / numColumns);
            return (
              <React.Fragment
                key={`multiple-mosaic-${chartId}-item-${index}-${rowIndex}-${columnIndex}`}
              >
                <svg
                  onMouseMove={(event: any) => handleMouseMove(event, item)}
                  onMouseLeave={(event: any) => handleMouseLeave(event)}
                  onMouseOver={(event: any) => handleMouseMove(event, item)}
                >
                  <MosaicChartImage
                    id={`multiple-mosaic-${chartId}-item-icon-${index}-${rowIndex}-${columnIndex}`}
                    pic={item.pic}
                    label={item.label}
                    width={columnWidth}
                    height={
                      sort !== 'similar' || rowHeight <= 0
                        ? rowHeight
                        : rowHeight - 15
                    }
                    x={columnIndex * columnWidth}
                    y={rowIndex * rowHeight}
                    color={color}
                    showItemsPreview={showItemsPreview}
                  />
                  {sort === 'similar' &&
                    columnWidth > 0 &&
                    getMultiTargetBars(
                      item,
                      columnIndex * columnWidth,
                      rowIndex * rowHeight + (rowHeight - 15),
                      columnWidth
                    )}
                </svg>
              </React.Fragment>
            );
          })}
          <rect
            x={0}
            y={0}
            width={width}
            height={height}
            fill={color}
            fillOpacity={sort === 'different' ? 0.5 : 0}
            stroke={color}
            strokeWidth={3}
            strokeOpacity={sort === 'different' ? 0.5 : 0}
            style={{ pointerEvents: 'none' }}
          />
        </Group>
      </StyledMultipleMosaicChartSvg>
    </StyledContentWrapper>
  );
};

export default MosaicContent;
